export default "__VITE_ASSET__4a0c4799__"